import axios from 'axios';

export const BalanceService = {
  async getBalance() {
    const res = await axios.get('payments/v1/transit/balance/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
